{
  "version": 1,
  "asset_id": "21e96f22-fa10-42cb-b054-64b4e60fb60a",
  "project_id": "e1a64cc6-0fc8-4a5b-9036-8fa01cc3f811",
  "url": "/__l5e/assets-v1/21e96f22-fa10-42cb-b054-64b4e60fb60a/clip-img_0042-poster-sm.webp",
  "r2_key": "a/v1/e1a64cc6-0fc8-4a5b-9036-8fa01cc3f811/21e96f22-fa10-42cb-b054-64b4e60fb60a/clip-img_0042-poster-sm.webp",
  "original_filename": "clip-img_0042-poster-sm.webp",
  "size": 9420,
  "content_type": "image/webp",
  "created_at": "2026-08-01T21:10:08Z"
}
